import { render } from "./AuthoriseMinipay.vue?vue&type=template&id=10aaaa1e&scoped=true&ts=true"
import script from "./AuthoriseMinipay.vue?vue&type=script&lang=ts"
export * from "./AuthoriseMinipay.vue?vue&type=script&lang=ts"

import "./AuthoriseMinipay.vue?vue&type=style&index=0&id=10aaaa1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aaaa1e"],['__file',"src/components/sell/AuthoriseMinipay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10aaaa1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10aaaa1e', __exports__)) {
    api.reload('10aaaa1e', __exports__)
  }
  
  module.hot.accept("./AuthoriseMinipay.vue?vue&type=template&id=10aaaa1e&scoped=true&ts=true", () => {
    api.rerender('10aaaa1e', render)
  })

}


export default __exports__